import { LOCALE_UZ } from './locale.constants';

export const DEFAULT_LOCALE = LOCALE_UZ;
export const DEFAULT_LIMIT = 10;
export const DEFAULT_LIMIT_100 = 100;

export const PROKURATURA_ORG_ID = '63d0fb220181794a44ddc649';
export const UZB_ID = '5d91e0abbc4c7dade230f681';
